export default {
  data() {
    return {
      sancion: 0,
      // tipoDeSancion: 'DIARIO',
      // porcentajeDeSancion: 1 / 100,
    };
  },
  methods: {
    mixCalcularSancion() {
      const importeAunRetenido = this.importeRetenidoAnterior - this.importeDevueltoAnterior;
      this.estimacion.importeMontoFueraPrograma = this.mixMontoFueraPrograma;

      let sancionAcumulada = 0;
      // Tipo de sancion
      // Mensual
      if (this.tipoDeSancion === 'MENSUAL') {
        sancionAcumulada = this.mixPendientePorEstimar
          * this.porcentajeDeSancion
          * (this.mixSancionGetDiasFueraPrograma / 30);
      } else {
        // SANCION DIARIA
        sancionAcumulada = this.mixPendientePorEstimar
          * this.porcentajeDeSancion
          * this.mixSancionGetDiasFueraPrograma;
      }

      // sancion pediente de cobro
      let sancionPedienteCobro = sancionAcumulada - this.mixSumaSancionesAnteriores;

      //
      if (sancionAcumulada > this.mixGetImporteGarantiaCumplimiento) {
        sancionPedienteCobro = this.mixGetImporteGarantiaCumplimiento
          - this.mixSumaSancionesAnteriores;
      }

      if (importeAunRetenido > sancionPedienteCobro) {
        // Cechar si es estimacion finiqito
        if (this.estimacion.esEstimacionFiniquito) {
          this.estimacion.importeDevuelto = importeAunRetenido;
        } else {
          this.estimacion.importeDevuelto = sancionPedienteCobro;
        }
      } else {
        this.estimacion.importeDevuelto = importeAunRetenido;
      }

      this.estimacion.importeSancion = sancionPedienteCobro;
    },
  },
  computed: {
    tipoDeSancion() {
      if (!this.contrato) return 'DIARIO';
      if (!this.contrato.periodicidadSancion) return 'DIARIO';

      return this.contrato.periodicidadSancion;
    },
    porcentajeDeSancion() {
      if (!this.contrato) return (1 / 100);
      if (!this.contrato.porcentajeSancion) return (1 / 100);

      return (this.contrato.porcentajeSancion / 100);
    },
    mixPendientePorEstimar() {
      if (this.estimacion.esEstimacionFiniquito) {
        return this.$numberRound(
          this.importeEstimadoActual - this.importeEstimadoAnteriorFinPrograma,
        );
      }
      return this.$numberRound(this.importeDelContrato - this.importeEstimadoAnteriorFinPrograma);
    },
    mixSancionGetDiasFueraPrograma() {
      const fechaFinalPrograma = this.programa.programaFinal.fechaTermino;
      const fechaEstimacionAl = this.estimacion.fechaAl;
      return this.$fechaDiffDias(fechaFinalPrograma, fechaEstimacionAl) - 1;
    },
    mixSumaSancionesAnteriores() {
      const estimaciones = this.estimaciones
        .filter(({ numero }) => numero < this.estimacion.numero);
      return this.$ObjSumar(estimaciones, 'importeSancion');
    },
    mixGetImporteGarantiaCumplimiento() {
      return this.$numberRound(this.contrato.total * 0.1);
    },
    importeEstimadoAnteriorFinPrograma() {
      return this.$ObjSumar(
        this.estimaciones.filter((estimacion) => estimacion.importeSancion <= 0),
        'importeEstimado',
      );
    },
    mixEstimacionesDentroPrograma() {
      const estimacionFinPrograma = this.estimaciones.find(
        ({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true,
      );

      if (!estimacionFinPrograma) return [];

      return this.estimaciones.filter(
        ({ numero }) => Number(numero) <= Number(estimacionFinPrograma.numero),
      );
    },
    mixMontoFueraPrograma() {
      const montoAnterior = this.$ObjSumar(this.mixEstimacionesDentroPrograma, 'importeEstimado');

      if (this.estimacion.esEstimacionFiniquito) {
        return this.importeEstimadoActual - montoAnterior;
      }
      return this.importeDelContrato - montoAnterior;
    },
  },
};
